module.exports = __webpack_public_path__ + "img/media-8.b5f8e553.png";